// extracted by mini-css-extract-plugin
export var deleteIcon = "_rq-5";
export var deleteOption = "_rq-3";
export var divider = "_rq-2";
export var downloadIcon = "_rq-4";
export var drawer = "_rq-0";
export var drawerFooter = "_rq-6";
export var drawerOpen = "_rq-1";
export var highlighted = "_rq-7";
export var lighterHighlight = "_rq-8";